module.exports = __webpack_public_path__ + "img/area-part4-423.670f51de.png";